import * as React from 'react';

import { ISVGProps } from './SVG';

export const ScreenRecorderSVG = ({ width, height, title, fill, secondaryFill }: ISVGProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 59.19 45.7">
    <title>{title}</title>
    <path
      className="secondary"
      d="M15.59,30.1a9.09,9.09,0,0,0-6.45-2.68h0a9.14,9.14,0,0,0,0,18.28h0a9.16,9.16,0,0,0,9.13-9.15A9,9,0,0,0,15.59,30.1Zm.89,6.47a7.34,7.34,0,1,1-7.33-7.34,7.33,7.33,0,0,1,7.33,7.34Z"
      fill={secondaryFill}
    />
    <circle className="secondary" cx="9.13" cy="36.56" r="5.26" fill={secondaryFill} />
    <path
      className="primary"
      d="M7.93,10V23.54c.4,0,.8-.06,1.2-.06A13.08,13.08,0,0,1,22.21,36.56h0a13.67,13.67,0,0,1-.2,2.22H56.14a3,3,0,0,0,3-3h0V10Z"
      fill={fill}
    />
    <path
      className="primary"
      d="M56.14,0H11A3,3,0,0,0,7.93,3.05V6.57H59.19V3.05a3,3,0,0,0-3-3ZM11.55,4.28a1,1,0,0,1-1-1h0a1,1,0,1,1,2,0,1,1,0,0,1-1,1Zm3.35,0a1,1,0,1,1,1-1,1,1,0,0,1-1,1Zm3.36,0a1,1,0,0,1-1-1h0a1,1,0,1,1,2,0,1,1,0,0,1-1,1ZM55.6,4.22H21.79a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1H55.6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1Z"
      fill={fill}
    />
  </svg>
);
